import Rodape from "componentes/Rodape";
import { Outlet } from "react-router-dom";
import Cabecalho from "../../componentes/Menu";


function PaginaBase(){
  return (
    <main>
      <Cabecalho />     
        
          <Outlet />
      <Rodape />              
      
    </main>
  )
}

export default PaginaBase;